/**
 * @voltxampere/schema — Annotation
 *
 * Per SPECS §1.5. Visual annotations layered over the canvas: text,
 * boxes, arrows, or embedded images.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
import { PointSchema } from "./_primitives.js";
export const AnnotationKindSchema = z.enum(["text", "box", "arrow", "image"]);
export const AnnotationStyleSchema = z
    .object({
    color: z.string().optional(),
    background: z.string().optional(),
    fontSize: z.number().positive().optional(),
})
    .optional();
export const AnnotationSchema = z
    .object({
    id: z.string(),
    kind: AnnotationKindSchema,
    position: PointSchema,
    size: z.object({ width: z.number(), height: z.number() }).optional(),
    content: z.string().optional(),
    style: AnnotationStyleSchema,
})
    .strict();
//# sourceMappingURL=annotation.js.map